<template>
  <Confirm ref="confirmRef" :max-width="maxWidth">
    <template v-slot:card-title="{ close }">
      <v-card-title class="alert-dialog__header">
        <div class="alert-dialog__header-inner">
          <span class="text-h6 alert-dialog__title">{{ $t('title') }}</span>
          <v-btn depressed icon class="alert-dialog__close" @click="close">
            <v-icon size="18">close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
    </template>
    <template v-slot:content>
      <p class="mb-2 text-body-2">{{ $t('msg[0]') }}</p>
      <p class="mt-0 mb-4 text-body-2">{{ $t('msg[1]') }}</p>
    </template>
    <template v-slot:footer="{ close }">
      <v-btn depressed text color="primary" class="text-none" @click="close">
        {{ $t('btn_maybe_later') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="hasVerificationEnabled"
        depressed
        color="primary"
        class="text-none"
        :to="'/account/verify-info'"
        @click="close">
        {{ $t('btn_complete_verification') }}
      </v-btn>
      <v-btn
        v-else-if="!checkInfoCompleted()"
        depressed
        color="primary"
        class="text-none"
        :to="'/account/information'"
        @click="close">
        {{ $t('btn_complete_account_info') }}
      </v-btn>
    </template>
  </Confirm>
</template>

<script>
import { mapGetters } from 'vuex'
import Confirm from '@/components/Confirm.vue'

export default {
  name: 'RestrictedAlert',
  components: {
    Confirm
  },
  i18n: {
    sharedMessages: {
      en: {
        title: 'One Quick Step',
        msg: [
          'Before you continue, we just need to verify a few details to help keep your account secure.',
          'This is a quick step to help us ensure a smooth ordering experience. Please complete the verification to proceed with your order.'
        ],
        btn_maybe_later: 'Maybe Later',
        btn_complete_verification: 'Verify & Continue',
        btn_complete_account_info: 'Complete Account Info'
      },
      zh_CN: {
        title: '只需简单一步',
        msg: [
          '继续之前，我们需要核实一些信息，以保障您的账户安全。',
          '只需简单一步，即可帮助我们为您提供顺畅的下单体验。请完成验证以继续下单。'
        ],
        btn_maybe_later: '稍后再说',
        btn_complete_verification: '验证并继续',
        btn_complete_account_info: '完善账户信息'
      }
    }
  },
  props: {
    maxWidth: {
      type: String,
      default: '596px'
    }
  },
  computed: {
    ...mapGetters('client', ['hasVerificationEnabled', 'checkInfoCompleted'])
  },
  methods: {
    open(data) {
      if (this.$refs.confirmRef) {
        this.$refs.confirmRef.open(data)
      }
    },
    close() {
      if (this.$refs.confirmRef) {
        this.$refs.confirmRef.close()
      }
    }
  }
}
</script>

<style scoped>
.alert-dialog__header-inner {
  width: 100%;
  position: relative;
  text-align: center;
}

.alert-dialog__title {
  display: inline-block;
  padding: 0 28px;
}

.alert-dialog__close {
  position: absolute;
  top: -10px;
  right: -15px;
  margin: 0;
}
</style>
